import { Server } from "@modelcontextprotocol/sdk/server/index.js";

import { registerTools } from "./tools.js";

// tsup define 으로 빌드타임 주입 — 비번들 실행(vitest 등)에서는 "dev".
declare const __CMS_MCP_VERSION__: string | undefined;
const VERSION =
  typeof __CMS_MCP_VERSION__ === "string" ? __CMS_MCP_VERSION__ : "dev";

export const SERVER_INSTRUCTIONS = `
roottale-cms-mcp는 RootTale CMS를 외부 사이트(주로 Next.js)에 연동하기 위한
통합 문서·예시 코드·공개 API 조회 tool을 제공합니다.

지켜야 할 규칙:
- RootTale 연동 관련 작업은 가장 먼저 listRootTaleDocs를 호출해 문서 목록을 파악하세요.
- 연동 코드를 작성하기 전 반드시 readRootTaleNextjsExampleCode를 호출해 예시 코드를
  참고한 후 그 패턴을 따라 작성하세요.
- API 키(rtlk_cust_*)는 서버 전용입니다. NEXT_PUBLIC_* 등 브라우저로 노출되는
  환경변수에 절대 넣지 마세요.
- 이미 학습된 내용이더라도 본 서버의 문서로 더블체크 후 작업하세요.
`.trim();

export function createServer(): Server {
  const server = new Server(
    { name: "roottale-cms", version: VERSION },
    { capabilities: { tools: {} }, instructions: SERVER_INSTRUCTIONS },
  );
  registerTools(server);
  return server;
}
